import { Ajax } from './axios'

export default {
  articlePageForH5POST (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/common/news/page', { ...param })
  },
  faceComparePOST (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/common/faceCompare', { ...param })
  },
  POSTFaceCompare (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/common/faceCompare', { ...param })
  },
  toPinyinPOST (word) {
    return Ajax.post('/api/gugongExaminee/v1/common/toPinyin', { word: word })
  },
  getNewsDetailGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/common/news/getNewsDetail`, { ...param })
  },
  // 获取当前时间
  getCurrentTimeGET () {
    return Ajax.get(`/api/gugongExaminee/v1/common/currentTime`)
  },
  // 地区查询所有地区
  getListAreaGET () {
    return Ajax.get(`/api/gugongExaminee/v1/common/listArea`)
  },
  getUserInfoGET () {
    return Ajax.get(`/api/gugongExaminee/v1/user/info`)
  },
};
